import './locationPicker.scss';

import { LocationPickerComponent } from './location_picker.component';

export const LocationPickerModule = angular
    .module('oo.multilocation.picker.container.locationPicker', [])
    .component('locationPicker', LocationPickerComponent)
    .name;
